import {
  activationCodeField,
  defaultSignUpFields,
  linkedInField,
  schoolField,
} from './questions.shared';
import { OnboardingQuestion } from '../onboarding.types';

type EducatorQuestionKey =
  | 'WHAT_DO_YOU_DO'
  | 'YOUR_NEEDS'
  | 'STUDENT_NEEDS'
  | 'CREATE_ACCOUNT'
  | 'ENGAGE_IN_NETWORKS';

export const EDUCATOR_QUESTIONS = (): Record<EducatorQuestionKey, OnboardingQuestion> => {
  return {
    WHAT_DO_YOU_DO: {
      title: 'What do you do?',
      subTitle: 'Select any that apply',
      featuredIcon: 'UserCircle',
      onComplete: 'CONTINUE_WITHOUT_SUBMIT',

      question: {
        type: 'CHECKBOX',

        profile_option_category_id: 'onboarding',
        profile_option_question_id: 'what_do_you_do',
        profile_option_source: 'onboarding',

        rules: {
          required: 'Please select at least one option',
        },
        options: [
          { label: 'Teacher', value: 'educator_teacher' },
          { label: 'Counselor/advisor', value: 'educator_counselor' },
          { label: 'Administrator', value: 'educator_administrator' },
        ],
      },
    },
    YOUR_NEEDS: {
      title: 'Your needs',
      subTitle: 'How can Backrs help you as an educator?',
      featuredIcon: 'UserCircle',
      onComplete: 'POST_PROFILE_OPTION_ANSWER',
      question: {
        type: 'CHECKBOX',

        profile_option_category_id: 'onboarding',
        profile_option_question_id: 'your_needs',
        profile_option_source: 'onboarding',

        rules: {
          required: 'Please select at least one option',
        },
        options: [
          { label: 'Save time', value: 'educator_save_time' },
          { label: 'Find high quality resources', value: 'educator_find_resources' },
          { label: 'Engage with students', value: 'educator_engage_students' },
          {
            label: 'Get insights on aspirations, status, and needs of students',
            value: 'educator_insights_students',
          },
        ],
      },
    },

    STUDENT_NEEDS: {
      title: 'Student needs',
      subTitle: 'What are the top needs of your students?',
      featuredIcon: 'UserCircle',
      onComplete: 'POST_PROFILE_OPTION_ANSWER',
      question: {
        type: 'CHECKBOX',
        profile_option_category_id: 'onboarding',
        profile_option_question_id: 'student_needs',
        profile_option_source: 'onboarding',
        rules: {
          required: 'Please select at least one option',
        },
        options: [
          {
            label: 'Career exploration',
            value: 'educator_career_exploration',
            recommendation: ['discover_jobs_sticker', 'resume_optimizer', 'boost_your_profile'],
          },
          {
            label: 'Internships and jobs',
            value: 'educator_internships_jobs',
            recommendation: ['discover_jobs_sticker', 'resume_optimizer', 'boost_your_profile'],
          },
          {
            label: 'College exploration',
            value: 'educator_college_exploration',
            recommendation: ['explore_universities_sticker', 'college_shortlist'],
          },
          {
            label: 'College admissions',
            value: 'educator_college_admissions',
            recommendation: ['improve_test_scores'],
          },
          {
            label: 'Building connections/social capital',
            value: 'educator_social_capital',
            recommendation: ['networking', 'seek_support'],
          },
          {
            label: 'Scholarships',
            value: 'educator_scholarships',
            recommendation: ['find_scholarships_sticker', 'lower_cost_of_college'],
          },
          {
            label: 'Improve mental/physical health',
            value: 'educator_mental_physical_health',
            recommendation: [
              'navigating_stress',
              'sleep_restoration',
              'family_dynamics',
              'growth_mindset',
            ],
          },
        ],
      },
    },
    CREATE_ACCOUNT: {
      title: 'Create an account',
      subTitle: 'Sign up in less than 2 minutes.',
      featuredIcon: 'UserCircle',
      onComplete: 'SUBMIT_USER_INFO',
      question: {
        type: 'FORM',
        fields: [...defaultSignUpFields, activationCodeField, schoolField],
      },
    },
    ENGAGE_IN_NETWORKS: {
      title: 'Engage in networks',
      subTitle: 'To use your time wisely and purposefully, we need to know a few things about you.',
      featuredIcon: 'Dataflow01',
      onComplete: 'POST_PROFILE_OPTION_ANSWER',
      question: {
        type: 'FORM',
        fields: [
          {
            name: 'zip_code',
            placeholder: 'Enter your zip code',
            type: 'text',
            rules: {
              required: 'Zip code is required',
            },
          },
          {
            name: 'CAREER_PATH_DROPDOWNS',
            type: 'text',
          },
          linkedInField,
        ],
      },
    },
  };
};

export const QUESTION_INDEX_TO_FIELDS_EDUCATOR: Record<number, string[]> = {
  0: ['what_do_you_do'], // WHAT_DO_YOU_DO
  1: ['your_needs'], // YOUR_NEEDS
  2: ['student_needs'], // STUDENT_NEEDS
  3: ['first_name', 'last_name', 'phone', 'email', 'password', 'invite_code', 'school'], // CREATE_ACCOUNT
  4: ['zip_code', 'career_path_category', 'career_path_subcategory', 'linkedin_url'], // ENGAGE_IN_NETWORKS
};
